import React from 'react';
import './LockupTemplate.scss';
import classNames from 'classnames';

export interface LockupTemplateProps {
  /** The size variation. Default large. */
  size?: 'small' | 'large';
  /** The content of the lockup. */
  children?: React.ReactNode;
  /** Additional classes to apply to the lockup. */
  className?: string;
}

/**
 * A lockup template component. Applies spacing between header and children.
 * @param size - The size variation.
 * @param children - The content of the lockup.
 * @param className - Additional classes to apply to the lockup.
 */
export const LockupTemplate: React.FC<LockupTemplateProps> = ({
  size = 'large',
  children,
  className,
  ...rest
}) => (
  <div
    className={classNames('vds-lockup-template', `vds-lockup-template--${size}`, className)}
    {...rest}>
    {children}
  </div>
);
